export const SET_SELECTED_DOCKET = 'SET_SELECTED_DOCKET';